import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export const IconTerminal = t0 => {
  const $ = _c(10);
  let height;
  let props;
  let size;
  let width;
  if ($[0] !== t0) {
    ({
      size,
      width,
      height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = props;
    $[3] = size;
    $[4] = width;
  } else {
    height = $[1];
    props = $[2];
    size = $[3];
    width = $[4];
  }
  const t1 = size ?? width ?? 24;
  const t2 = size ?? height ?? 24;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fill="currentColor" fillRule="evenodd" d="M6.762 5.059c-2.234.377-4.126 2.118-4.727 4.349l-.147.544v44.096l.147.544c.539 2 2.065 3.573 4.08 4.205l.573.179h50.496l.544-.143c2.03-.534 3.685-2.19 4.237-4.241l.147-.544V32c0-23.838.02-22.381-.336-23.392a5.55 5.55 0 0 0-1.432-2.18c-.64-.6-1.237-.941-2.148-1.227l-.564-.177-25.28-.009c-13.904-.005-25.42.015-25.59.044m.163 4.13a2.3 2.3 0 0 0-.584.452c-.497.565-.453-1.602-.453 22.359 0 23.96-.044 21.794.453 22.36a2.3 2.3 0 0 0 .584.45l.332.166h49.486l.332-.165c.182-.091.445-.294.583-.452.498-.565.454 1.61.454-22.423 0-23.803.033-21.947-.402-22.443a1.7 1.7 0 0 0-.462-.35c-.246-.112-1.209-.116-25.123-.118L7.256 9.024zm7.114 4.38c-.315.098-.8.453-1.028.755-.404.532-.5 1.337-.237 1.968.162.387.539.733 3.402 3.119 1.524 1.27 2.763 2.328 2.753 2.353s-1.327 1.14-2.93 2.476c-1.6 1.337-2.953 2.499-3.003 2.583-.298.495-.35.67-.35 1.177.001.41.032.576.156.832.197.408.582.793.99.99.451.218 1.213.224 1.647.012.372-.182 7.931-6.468 8.253-6.863.538-.661.581-1.562.11-2.305-.136-.215-1.228-1.162-4.058-3.52-2.129-1.774-4.02-3.31-4.2-3.413-.27-.154-.417-.19-.817-.206-.268-.01-.577.009-.688.043m13.286 12.502c-.67.18-1.273.845-1.408 1.552-.193 1.015.444 2.04 1.43 2.303.439.117 11.676.133 12.218.018.907-.193 1.541-.993 1.541-1.944 0-.93-.614-1.724-1.502-1.942-.442-.109-11.874-.096-12.28.013" clipRule="evenodd" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== t1 || $[8] !== t2) {
    t4 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" width={t1} height={t2} {...props}>{t3}</svg>;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
IconTerminal.displayName = 'IconTerminal';